module.exports = __webpack_public_path__ + "static/img/t1-1.ce879a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1-1.png
// module id = ka2l
// module chunks = 1